import { render, staticRenderFns } from "./MicroCategoriesProductsFilter.vue?vue&type=template&id=42365ea5&lang=pug"
import script from "./MicroCategoriesProductsFilter.vue?vue&type=script&lang=js"
export * from "./MicroCategoriesProductsFilter.vue?vue&type=script&lang=js"
import style0 from "./MicroCategoriesProductsFilter.vue?vue&type=style&index=0&id=42365ea5&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports